import { Card } from "react-bootstrap";
import TimerComponent from "../Timer";
import log from "loglevel";
import moment from "moment";

const QuizTimeLeft = ({ labAvailableTime, isDisabled, labExpired, millisecondsLeft, setAutoSub, setIsLabExpired }) => {

    const handleAutoSubmit = () => {
        log.log("Auto-submitting...");
        setAutoSub(true);
        if (labAvailableTime) {
            let till = moment(labAvailableTime);
            let now = moment();
            log.log({ labAvailableTime: now.isAfter(till) })
            if (now.isAfter(till)) {
                setIsLabExpired(true);
            } else {
                setIsLabExpired(true);
            }
        }
        const submitButton = document.getElementById("submitButton");
        if (submitButton) {
            submitButton.click();
        } else {
            log.error("Submit button not found");
        }
    }

    return (
        <>
            {!isDisabled && labAvailableTime && !labExpired && <div style={{ marginBottom: "30px" }}>
                <Card style={{ marginRight: "10px", borderRadius: "20px", backgroundColor: "#F5FFFA" }}>
                    <Card.Footer className="text-muted" style={{ padding: "35px" }}>
                        <TimerComponent labAvailableTill={labAvailableTime} onTimeUp={handleAutoSubmit} millisecondsLeft={millisecondsLeft} />
                    </Card.Footer>
                </Card>
            </div>}
        </>
    )
}

export default QuizTimeLeft;